module.exports = __webpack_public_path__ + "img/frown.27ad95ab.svg";